import { createReducer, on, Action } from '@ngrx/store';
import * as SchedulesActions from './schedules.actions';
import { ISchedule } from '@care-portals/api-interfaces';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';

export const SCHEDULES_FEATURE_KEY = 'schedules';

interface ScheduleEntity extends ISchedule {}

export interface State extends EntityState<ScheduleEntity> {
  schedules: ISchedule[];
  activeScheduleId: string;
  drawer: {
    open: boolean;
    loading: boolean;
  };
  loading: boolean;
  error: any;
  updatedAt?: Date;
}

export interface SchedulesPartialState {
  readonly [SCHEDULES_FEATURE_KEY]: State;
}

export function selectId(schedule: ISchedule): string {
  return schedule?._id;
}

export const scheduleAdapter: EntityAdapter<ScheduleEntity> =
  createEntityAdapter<ScheduleEntity>({ selectId });

export const initialState: State = scheduleAdapter.getInitialState({
  schedules: [],
  activeScheduleId: null,
  drawer: {
    open: false,
    loading: false
  },
  loading: false,
  error: null
});

const schedulesReducer = createReducer(
  initialState,

  /* ----------------------------- Get Schedule By Id ----------------------------- */

  on(SchedulesActions.getSchedule, state => ({
    ...state,
    loading: true,
    error: null
  })),
  on(SchedulesActions.getScheduleSuccess, (state, { schedule }) =>
    scheduleAdapter.upsertOne(schedule, {
      ...state,
      loading: false,
      activeScheduleId: schedule?._id
    })
  ),
  on(SchedulesActions.getScheduleFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false,
    activeScheduleId: null
  })),

  /* ----------------------------- Sync schedule ---------------------------- */

  on(SchedulesActions.syncSchedule, (state, { id }) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(SchedulesActions.syncScheduleSuccess, (state, { schedule }) =>
    scheduleAdapter.updateOne(
      {
        id: schedule._id,
        changes: { ...schedule }
      },
      {
        ...state,
        loading: false,
        error: null
      }
    )
  ),
  on(SchedulesActions.syncScheduleFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false
  })),

  /* ---------------------------- Update schedule --------------------------- */

  on(SchedulesActions.updateSchedule, (state, { changes }) => ({
    ...state,
    loading: true,
    error: null
  })),
  on(SchedulesActions.updateScheduleSuccess, (state, { schedule }) =>
    scheduleAdapter.updateOne(
      {
        id: schedule._id,
        changes: { ...schedule }
      },
      {
        ...state,
        loading: false,
        error: null
      }
    )
  ),
  on(SchedulesActions.updateScheduleFailure, (state, { error }) => ({
    ...state,
    error,
    loading: false
  })),

  /* --------------------------------- drawer --------------------------------- */
  on(SchedulesActions.closeDrawer, (state, {}) => ({
    ...state,
    createLead: { ...state.drawer, open: false }
  })),

  /* ---------------------------- Clean Active Schedule --------------------------- */

  on(SchedulesActions.setActiveSchedule, (state, { id }) => ({
    ...state,
    activeScheduleId: id
  })),

  /* ---------------------------- Clean Active Schedule --------------------------- */

  on(SchedulesActions.cleanActiveSchedule, state => ({
    ...state,
    activeScheduleId: null
  }))
);

export function reducer(state: State | undefined, action: Action) {
  return schedulesReducer(state, action);
}
